// This is sync'ed with https://github.com/zapier/zapier-platform/blob/main/packages/legacy-scripting-runner/index.js#L249-L265
const JS_GLOBALS = [
  '_',
  'crypto',
  'async',
  'moment',
  'DOMParser',
  'XMLSerializer',
  'atob',
  'btoa',
  'z',
  '$',
  'require',
  'ErrorException',
  'HaltedException',
  'StopRequestException',
  'ExpiredAuthException',
  'RefreshTokenException',
  'InvalidSessionException',
];

export const JSHINT_OPTIONS = [
  { globals: JS_GLOBALS.reduce((a, g) => ({ ...a, [g]: true }), {}) },
];
